import { TOrder } from '../../../../1stlog-ui/src/components/OrderDetails/helpers'
import { TOrderEntryExternalValues, TOrderEntryFormValues } from '../types'

export default function externalValuesToOrderEntryValues(
  data: TOrderEntryExternalValues,
  existingOrder?: TOrder,
): TOrderEntryFormValues {
  const isPickup = existingOrder?.sla_object?.isPickup
  return {
    pickup: { address: data.pickupAddress ?? {}, isEdit: isPickup },
    delivery: { address: data.deliveryAddress ?? {}, isEdit: !isPickup },
    colis: data.colis ?? [],
    defaultSlaTypeId: data.slaType ? -1 : undefined,
    defaultSlaTypeName: data.slaType,
  }
}
